import { gql } from '@apollo/client';

const DELETE_INCOMINGORDERS_VIEW = gql`mutation deleteView($viewId: Int!) {
	incomingOrders {
		deleteView(viewId: $viewId)
	}
}`;

export default DELETE_INCOMINGORDERS_VIEW;